import React from 'react';

const TrainingDetail = ({variation, placeData}) => {
  if (!placeData) return null;

  const mapsUrl = placeData.gps
    ? `https://www.google.com/maps?q=${encodeURIComponent(placeData.gps)}`
    : null;

  return (
    <div className="training-detail product-variation--training-center">
      <div className="training-detail--inner row">

        {/* Left column */}
        <div className="training-detail--col col-xxs-12 col-xs-12 col-sm-12 col-md-6 col-lg-6">

          {placeData.address && placeData.address[0] && (
            <div className="training-detail--section">
              <h5 className="training-detail--section-title">{Drupal.t("Lieu")}</h5>
              <div className="contact">
                <i className="icon-pin" aria-hidden="true"></i>
                <div>
                  <p className="address" translate="no">
                    <span className="address-line1">{placeData.address[0].address_line1}</span>
                    <span className="postal-code">{placeData.address[0].postal_code}</span>
                    <span className="locality">{placeData.address[0].locality}</span>
                  </p>
                  {mapsUrl && (
                    <a href={mapsUrl} className="training-detail--map-link" target="_blank" rel="noopener noreferrer">
                      {Drupal.t("Voir sur la carte")}
                    </a>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Right column */}
        <div className="training-detail--col col-xxs-12 col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <div className="training-detail--section">
            <h5 className="training-detail--section-title">{Drupal.t("Contact centre")}</h5>
            {placeData.phone && (
              <div className="contact">
                <i className="icon-phone" aria-hidden="true"></i>
                <div>
                  <a href={`tel:${placeData.phone}`}>{placeData.phone}</a>
                  {placeData.schedule && (
                    <small dangerouslySetInnerHTML={{__html: placeData.schedule}} />
                  )}
                </div>
              </div>
            )}
            {placeData.email && (
              <div className="contact">
                <i className="icon-mail" aria-hidden="true"></i>
                <a href={`mailto:${placeData.email}`}>{placeData.email}</a>
              </div>
            )}
          </div>
        </div>

      </div>

      <div className="training-detail--inner row">
        {/* Left column */}
        <div className="training-detail--col col-xxs-12 col-xs-12 col-sm-12 col-md-12 col-lg-12">
          {variation.price && (
            <div className="training-detail--section">
              <h5 className="training-detail--section-title training-detail--section-title--no-capitalize">{Drupal.t("Prix")}</h5>
              <div className="contact">
                {parseFloat(variation.price).toFixed(2)} €
              </div>
            </div>
          )}

          {variation.schedule && (
            <div className="training-detail--section">
              <h5 className="training-detail--section-title training-detail--section-title--no-capitalize">{Drupal.t("Horaires de la formation")}</h5>
              <div className="contact">
                <div dangerouslySetInnerHTML={{__html: variation.schedule}} className="schedule-content" />
              </div>
            </div>
          )}

          {variation.manager_info && (
            <div className="training-detail--section">
              <h5 className="training-detail--section-title training-detail--section-title--no-capitalize">{Drupal.t("Contact formation")}</h5>
              <div className="contact">
                <div dangerouslySetInnerHTML={{__html: variation.manager_info}} />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
    
  );
};

export default TrainingDetail;
